module.exports = __webpack_public_path__ + "static/gallery-8-776817cb6bd9616d0f38f39aa7127ae9.jpg";